import React from 'react';
import './Button.scss';
import loading from './loading.svg';
import ErrorIcon from '../assets/error-red.png';
import SuccessIcon from '../assets/success-green.png';

type BtnType = 'submit' | 'button' | 'reset';
type AlertType = 'success' | 'error';

export interface AlertI {
  type: AlertType;
  message: string;
}

interface ButtonProps {
  children?: React.ReactNode | string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: BtnType;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  spinColor?: string;
  alert?: AlertI | null;
}

export const Button: React.FC<ButtonProps> = (props) => {
  return (
    <React.Fragment>
      <button
        style={{ ...props.style, cursor: props.disabled ? 'not-allowed' : 'pointer' }}
        className={props.className?.length ? 'sign-up '.concat(props.className) : 'sign-up'}
        type={props.type}
        onClick={props.onClick}
        disabled={props.disabled}
      >
        {props.loading ? (
          <img
            src={loading}
            alt={'l'}
            style={{ marginLeft: '8px', marginTop: '1px', color: props.spinColor }}
            width="30px"
            height="15px"
          />
        ) : (
          props.children
        )}
      </button>
      {props.alert ? (
        <div className="error-container">
          {props.alert.type === 'success' ? (
            <img width="15px" height="15px" src={SuccessIcon} alt="success" />
          ) : (
            <img width="15px" height="15px" src={ErrorIcon} alt="error" />
          )}

          <span className={props.alert.type === 'success' ? 'login-success' : 'login-error'}>
            {props.alert.message}
          </span>
        </div>
      ) : null}
    </React.Fragment>
  );
};
